import { merge, mergeDeep } from '../../../../utils/state';
import { TYPES } from './actions';
import entity from '../../entities/jobs/entity';

const coreReducer = entity.getReducer();

const initialState = {
  searchQuery: '',
  filterOptions: {},
  sortOptions: {
    sort_field: 'date_created',
    desc_sort: 'true',
  },
  error: null,
  isLoading: false,
  jobIds: [],
  jobTemplates: [],
  jobTitles: [],
  jobSummary: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TYPES.LOAD_REQUEST:
      return merge(state, {
        isLoading: true,
      });
    case TYPES.LOAD_REQUEST_SUCCESS:
      return mergeDeep(state, {
        jobIds: action.payload,
        error: false,
        isLoading: false,
      });
    case TYPES.LOAD_REQUEST_ERROR:
      return merge(state, {
        error: action.payload,
      });
    case TYPES.GET_TEMPLATES:
      return merge(state, {
        jobTemplates: [],
        jobTitles: [],
        isLoading: true,
      });
    case TYPES.GET_TEMPLATES_SUCCESS:
      return mergeDeep(state, {
        jobTemplates: action.payload,
        jobTitles: action.payload,
        error: false,
        isLoading: false,
      });
    case TYPES.GET_TEMPLATES_ERROR:
      return merge(state, {
        error: action.payload,
        isLoading: [],
      });
    case TYPES.GET_JOB_SUMMARY:
      return merge(state, {
        jobSummary: {},
        isLoading: true,
      });
    case TYPES.GET_JOB_SUMMARY_SUCCESS:
      return mergeDeep(state, {
        jobSummary: action.payload,
        error: false,
        isLoading: false,
      });
    case TYPES.GET_JOB_SUMMARY_ERROR:
      return merge(state, {
        error: action.payload,
        isLoading: false,
      });
    case TYPES.CLEAR_SEARCH_JOB_TITLE:
      return merge(state, {
        jobTitles: [],
      });
    case TYPES.CLEAR_JOB_TEMPLATES:
      return merge(state, {
        jobTemplates: [],
      });
    case TYPES.UPDATE_FILTER_OPTIONS:
      return merge(state, {
        filterOptions: action.payload,
      });
    case TYPES.UPDATE_SEARCH_QUERY:
      return merge(state, {
        searchQuery: action.payload,
      });
    case TYPES.UPDATE_SORT_OPTIONS:
      return merge(state, {
        sortOptions: action.payload,
      });
    default:
      return coreReducer(state, action);
  }
}
